import React, { useState } from 'react';
import { Modal } from 'react-native';
import { websitePreview, websiteSchema, websiteZip, type Website } from '@ventureroom/core';
import { Copy } from './components';
import { useApp } from './provider';
import { saveArtifact } from './artifact-download';
export function WebsiteCard({ site, artifactId }: { site: Website; artifactId?: string }) {
  const app = useApp();
  const [expanded, setExpanded] = useState(false);
  const [error, setError] = useState('');
  const html = websitePreview(websiteSchema.parse(site));
  async function download() {
    try {
      await saveArtifact(
        artifactId ? await app.artifact(artifactId) : websiteZip(site),
        'venture-website.zip',
        'application/zip',
      );
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Download failed.');
    }
  }
  return (
    <div style={{ marginTop: 8, width: '100%', minWidth: 0, maxWidth: '100%' }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: 8 }}>
        <button onClick={() => void download()}>Download ZIP</button>
        <button onClick={() => setExpanded(true)}>Expand preview</button>
      </div>
      {!!error && <Copy>{error}</Copy>}
      {!expanded && (
        <iframe
          title="Generated website preview"
          srcDoc={html}
          sandbox="allow-scripts"
          referrerPolicy="no-referrer"
          style={{ width: '100%', height: 400, border: 0 }}
        />
      )}
      <Modal visible={expanded} onRequestClose={() => setExpanded(false)}>
        <div
          style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: 'white' }}
        >
          <button onClick={() => setExpanded(false)} style={{ minHeight: 44 }}>
            Close preview
          </button>
          <iframe
            title="Generated website fullscreen"
            srcDoc={html}
            sandbox="allow-scripts"
            referrerPolicy="no-referrer"
            style={{ width: '100%', flex: 1, border: 0 }}
          />
        </div>
      </Modal>
    </div>
  );
}
